import type { MessageCreateDto } from '../types/message-create.dto';
import type { MessageCreateModel } from '../types/message-create.model';

export const toMessageCreateDto = (model: MessageCreateModel): MessageCreateDto => ({
	content: {
		title: {
			text: model?.content?.title?.text ?? '',
		},
		body: {
			text: model?.content?.body?.text ?? '',
		},
	},
	recipient_groups:
		model?.recipientGroups?.map((group) => ({
			group_number: group.groupNumber,
			org_id: group.orgId,
			recipients: group.recipients?.map((recipient) => ({
				id: recipient.id,
				type: recipient.type,
			})),
		})) ?? [],
});
